module.exports = __webpack_public_path__ + "static/media/stats-illustration.a200bad4.svg";